import React, { useEffect, useState } from 'react';
import { EstimateViewModel } from '../../models/estimate/EstimateViewModel';
import api from '../../services/api';
import { useAuth } from '../../contexts/auth';

type SentEstimateEmail = {
  id: number;
  estimateId: number;
  to: string[];
  subject: string;
  html: string;
  createdAt: string;
};

interface SentEstimateEmailListProps {
  estimate: EstimateViewModel;
}

export default function SentEstimateEmailList({
  estimate,
}: SentEstimateEmailListProps) {
  const {
    user: { organization },
    isAdmin,
  } = useAuth();
  const [sentEstimateEmails, setSentEstimateEmails] = useState<
    SentEstimateEmail[]
  >([]);

  function formatCell(
    top: JSX.Element | string,
    bottom: JSX.Element | string = ''
  ) {
    return (
      <div className='d-flex flex-column'>
        <div>{top}</div>
        {bottom ? (
          <div>
            <small className='text-muted'>{bottom}</small>
          </div>
        ) : undefined}
      </div>
    );
  }

  const getSentEstimateEmails = async () => {
    try {
      const { data } = await api.get(
        `organizations/${organization.id}/estimates/${estimate.id}/emails`
      );
      setSentEstimateEmails(data.data);
    } catch (e) {
      console.log(e);
    }
  };

  useEffect(() => {
    if (organization && estimate) getSentEstimateEmails();
  }, [organization, estimate]);

  return (
    <table className='table table-hover'>
      <thead>
        <tr>
          <th scope='col'>#</th>
          <th scope='col'>Data</th>
          <th scope='col'>Assunto</th>
          <th scope='col'>Destinatários</th>
        </tr>
      </thead>
      <tbody>
        {sentEstimateEmails.map((i) => {
          const createdAt = new Date(i.createdAt);
          return (
            <tr key={i.id}>
              <th scope='row'>{i.id}</th>
              <td>
                {formatCell(
                  createdAt.toLocaleDateString(),
                  createdAt.toLocaleTimeString()
                )}
              </td>
              <td>{i.subject}</td>
              <td>{i.to.join(', ')}</td>
            </tr>
          );
        })}
      </tbody>
    </table>
  );
}
